import { RollbackServiceService } from './../../../../rollback/services/rollback-service.service';
import { Ministry } from './../../../models/ministry.model';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Agency } from '../../../models/agency.model';

@Component({
  selector: 'app-agency-list',
  templateUrl: './agency-list.component.html',
  styleUrls: ['./agency-list.component.scss']
})
export class AgencyListComponent implements OnInit {

  agencyList : Agency = new Agency();
  ministryListDD : any;
  searchingForm: FormGroup = this.fb.group({
    stpMinistryId: [null],
    agencyName:['']
  });

  listView : any;
  total : number;
  page : number = 1;
  size : number = 10;
  sortingKey : string;
  sortingValue : string;

  constructor(private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notification: NzNotificationService,
    private nzMessageService: NzMessageService,
    private utilityService: UtilityService) {

      this.stpRegistrationStorageService.getAllStpMinistries().subscribe({
        next: (res: any) => {
          this.ministryListDD = res.data;

        }
      });;

     }

  ngOnInit(): void {
    this.getAgencyList();
  }


  getAgencyList()
  {
    this.agencyList.ministryId = this.searchingForm.value.stpMinistryId;
    this.agencyList.agencyName = this.searchingForm.value.agencyName;
    this.agencyList.pageSize = this.size;
    this.agencyList.pageNumber = this.page;
    this.agencyList.sortingKey = this.sortingKey;
    this.agencyList.sortingValue = this.sortingValue;

    this.stpRegistrationStorageService.getAgencyList(this.agencyList).subscribe({
      next: (response: any) =>{

        this.listView = response?.data?.content;
        this.total = response.data?.totalElements;


        if(!response.success)
        {

          this.notification.error('Failed!', 'Unable to find any data!');
        }


      },
      error: (error: string) => this.notification.error('Failed', error),
    });
  }

  reset() {
    this.searchingForm.reset();
    this.getAgencyList();
  }

  onEdit(id: number): void {
    this.router.navigate(['/home/stp-registration/add-agency/', id]);
  }

  onDelete(id?: number): void {
    this.stpRegistrationStorageService.deleteAgency(id).subscribe({
      next: (response: { success: boolean; message: string; }) => {
        if (response.success) {
          this.notification.success('Success!', response.message);
          this.getAgencyList();
        } else if (response.success == false) {
          this.notification.error('error!', response.message);
        }
      },

      error: (error: string) => this.notification.error('Failed', 'Unable to delete data'),
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    console.log("Inside Query ", params);
    this.page = params.pageIndex;
    this.size = params.pageSize;

    params.sort.forEach((element: { value: string | null; key: string }) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });
     this.getAgencyList();
  }

  stringTypeSorting(sortKey: string, sortVal: string) {




    this.listView.sort((a: any, b: any) => {
      let occupationA = a[sortKey];
      let occupationB = b[sortKey];

      if (sortVal == "ascend") {
        return occupationA.toLowerCase() > occupationB.toLowerCase() ? 1 : -1;
      } else {
        return occupationA.toLowerCase() < occupationB.toLowerCase() ? 1 : -1;
      }

    });




  }

}
